import { styled } from '@mui/material/styles';

export const DeviceLogo = styled('div', { shouldForwardProp: (propName) => propName !== 'src' })(({ theme, src }) => ({
  width: 275,
  height: 275,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundColor: theme.palette.primary.main,
  WebkitMask: `url("${src}") center no-repeat`,
  margin: theme.spacing(5, 0),
}));
